<div class="_relative _w-full">
    <fieldset class="_input-rounded _relative _bg-transparent"
        [ngClass]="{'_border-transparent' : menuPanelActive || !border}">
        <div class="_input-rounded _h-form-field-fat _bg-transparent _border-primary-1 _center-xy-absolute _outline-inset _shadow" 
            [ngClass]="{ '_hidden' : !menuPanelActive }"
            [ngStyle]="{ 'width' : 'calc(100% + 2px)' }">
        </div>
        <label for="regionSelector" class="_cursor-pointer">
            <i class="fa-light fa-map-location _mr-2"></i>
        </label>
        <input 
            id="regionSelector" 
            class="_w-full _h-full _cursor-pointer _overflow-ellipsis" 
            readonly
            [formControl]="whereToControl" 
            (click)="menuPanelActive = true">
        <i [ngClass]="{ 
                '_text-primary-1-tint-20 _pointer-events-none _cursor-default' : selectedRegionName === defaultRegionName, 
                '_cursor-pointer' : selectedRegionName !== defaultRegionName
            }"
            class="fa-light fa-xmark _z-10" 
            (click)="searchAllDestinations()">
        </i>
    </fieldset>
    <div *ngIf="menuPanelActive" 
        [ngClass]="{ '_absolute _w-full _min-w-max _z-10 _shadow' : !inline }"
        class="_border _border-primary-1 _bg-white _mt-4 _rounded-lg _p-4 _h-50vh _overflow-scroll _no-scrollbar">
        <app-menu-panel 
            [items]="allRegionsList" 
            [selectedRegion]="selectedRegionName"
            (regionSelection)="onNext($event)">
        </app-menu-panel>
    </div>
</div>



